<div class="alert alert--error" *ngIf="(cartFacade.isLoading$ | async) === false && ((cartFacade.isUnavailable$ | async) || (cartFacade.isPartiallyUnavailable$ | async))">
	<mat-icon svgIcon="mdi-alert-circle-outline" class="alert--icon"></mat-icon>
	<div class="alert--text"><b>Hinweis:</b>&nbsp;Mindestens ein ausgewählter Artikel ist nicht verfügbar. Bitte korrigiere deine Auswahl um mit der Bestellung fortzufahren.</div>
</div>
